import { ACTIONS } from "./actions";

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_CURRENT_SECTION: {
      const updatedVisited = state.visited.includes(action.value.name)
        ? state.visited
        : [...state.visited, action.value.name];

      return {
        ...state,
        currentSection: action.value,
        visited: updatedVisited,
      };
    }
    default:
      return state;
  }
};
